import { storeToRefs } from 'pinia';
import { type Ref, computed, watch } from 'vue';
import type { ComputedRef } from 'vue';

import { useToastStore } from '@/stores';

export type ToastType = 'error' | 'success' | 'info' | 'warning';
interface Toast {
  setToast: (content: string, type: ToastType) => void;
  showToast: Ref<boolean>;
  toastContent: Ref<string>;
  resetToast: () => void;
  toastType: Ref<ToastType>;
  toastIsSuccess: Ref<boolean>;
}

export const useToast = (delay = 5000): Toast => {
  const toastStore = useToastStore();
  const { setToast } = toastStore;
  const { showToast, toastContent, toastType } = storeToRefs(toastStore);
  const toastIsSuccess: ComputedRef<boolean> = computed(() => toastType.value === 'success');

  const resetToast = () => toastStore.$reset();

  watch(showToast, (newValue) => {
    if (newValue === true) {
      setTimeout(() => resetToast(), delay);
    }
  });

  return { setToast, showToast, toastContent, resetToast, toastType, toastIsSuccess };
};
